import { pick } from 'lodash-es'

import { getFormValue } from '../utils'
import { getSpotStepFromValues } from './format_values_to_server_data'

export const prepareValuesForPreview = (eventType, formValues) => {
  if (formValues.spotStep === undefined) {
    return pick(eventType, 'spot_step')
  }

  return {
    spot_step: getFormValue(eventType.spot_step, getSpotStepFromValues(formValues), false),
  }
}
